import React from 'react';
import PropTypes from 'prop-types';
import { tokens } from '@fluentui/react-theme';

import { ReactComponent as AgingIcon } from './icons/N600-aging.svg';
import { ReactComponent as CfdIcon } from './icons/N600-cfd.svg';
import { ReactComponent as DashboardIcon } from './icons/N600-dashboard-icon.svg';
import { ReactComponent as HeatmapIcon } from './icons/N600-heat-map.svg';
import { ReactComponent as HistogramIcon } from './icons/N600-histogram.svg';
import { ReactComponent as MonteCarloIcon } from './icons/N600-monte-carlo.svg';
import { ReactComponent as RunChartIcon } from './icons/N600-run-chart.svg';
import { ReactComponent as ScatterplotIcon } from './icons/N600-scatterplot.svg';
import { ReactComponent as SourceDataIcon } from './icons/N600-source-data.svg';

function ChartsDropdownIcons({ name, isSelected }) {
  switch (name) {
    case 'Cumulative Flow Diagram':
      return <CfdIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Dashboard':
      return <DashboardIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Aging Work In Progress':
      return <AgingIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Heat Map':
      return <HeatmapIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Cycle Time Histogram':
      return <HistogramIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Throughput Histogram':
      return <HistogramIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Monte Carlo: How Many':
      return <MonteCarloIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Flow Efficiency':
      return <MonteCarloIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Monte Carlo: When':
      return <MonteCarloIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Throughput Run Chart':
      return <RunChartIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'WIP Run Chart':
      return <RunChartIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    case 'Cycle Time Scatterplot':
      return <ScatterplotIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
    default:
      return <SourceDataIcon fill={tokens[isSelected ? 'colorBrandForeground2Pressed' : 'colorBrandForeground2']} height={40} width={40} style={{ margin: '-9px' }} />;
  }
}

ChartsDropdownIcons.propTypes = {
  name: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default ChartsDropdownIcons;
